// faqheader.js (Updated)
import React from "react";
import "./faq.css";

const FaqHeader = () => {
    return (
        <div className="faq-header">
            <h1>Frequently Asked Questions</h1>
            <p className="lead">
                Find answers to common questions about Indian Matchmaking
            </p>
        </div>
    );
};

export default FaqHeader;

// import React from "react";
// import "./faq.css";

// const FaqHeader = () => {
//     return (
//         <div className="faq-header">
//             <h1>FAQ Page</h1>
//         </div>
//     );
// };

// export default FaqHeader;